@if (collection && collection.length > 0) {
  @for (item of collection; track item.key) {
    @if (!(item.hideIfNull && resolveKey(item.key) === null) && !(item.hideIf && item.hideIf(data))) {
      <app-value-group>
        <label appLabel>{{ item.title | translate }}</label>
        <div class="font-normal text-secondary dark:text-dark-muted flex justify-end">
          <app-value-data-renderer
            [value]="resolveKey(item.key)"
            [cellRenderer]="item.cellRenderer"
            [params]="item.cellRendererParams"
            [data]="data"
            [key]="item.key"
          ></app-value-data-renderer>
        </div>
      </app-value-group>
    }
  }
}
